import { Component, Input, inject } from '@angular/core';
import { injectDispatch } from '@ngrx/signals/events';
import { ThemeSelectorComponent } from '@navstation-portal/shared/ui/design-system';
import { ThemeService } from '@navstation-portal/shared/data-access/theme';
import { Theme } from '@navstation-portal/shared/data-model/theme';
import {
  authEvents,
  AuthStore,
} from '@navstation-portal/shared/data-access/auth';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { IconNames } from '@navstation-portal/shared/data-model/ui';
import { VesselReportsStore } from '@navstation-portal/reporting/data-access/vessel-reports';
import { ReportStore } from '@navstation-portal/reporting/data-access/vessel-report';
import { environment } from '../../../environments/environment';

@Component({
  selector: 're-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.css',
  imports: [ThemeSelectorComponent, IconComponent],
})
export class UserMenuComponent {
  IconNames = IconNames;
  @Input() email?: string | null;

  readonly themeService = inject(ThemeService);
  readonly vesselReportsStore = inject(VesselReportsStore);
  readonly reportStore = inject(ReportStore);
  readonly authStore = inject(AuthStore);

  events = injectDispatch(authEvents);

  isMenuOpen = false;
  version = environment.appVersion;

  onThemeChange = (theme: Theme) => this.themeService.setTheme(theme);

  onToggleMenu = (): void => {
    this.isMenuOpen = !this.isMenuOpen;
  };

  onSignOut = (): void => {
    this.onCloseMenu();
    this.events.logout();
  };

  onCloseMenu = (): void => {
    this.isMenuOpen = false;
  };
}
